// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCheckbox_container__2Awdq","icon":"CustomCheckbox_icon__20gzw"};